import { useCallback, useMemo } from 'react';
import { useDisconnect as useWagmiDisconnect } from 'wagmi';

import { INITIAL_WALLET_DETAILS } from '../contexts/app-state-context';
import { useWeb3State } from './use-web3-state';

export const useDisconnect = (
  ...args: Parameters<typeof useWagmiDisconnect>
) => {
  const { updateWalletDetails, resetStatus } = useWeb3State();
  const { disconnectAsync: coreDisconnectAsync, ...rest } = useWagmiDisconnect(
    ...args,
  );

  const disconnectAsync = useCallback(
    async (options?: Parameters<typeof coreDisconnectAsync>[1]) => {
      await coreDisconnectAsync(undefined, options);

      resetStatus();
      updateWalletDetails(prev => ({
        ...prev,
        address: null,
        balance: INITIAL_WALLET_DETAILS.balance,
      }));
    },
    [coreDisconnectAsync],
  );

  return useMemo(() => ({ disconnectAsync, ...rest }), [disconnectAsync, rest]);
};
